module.exports = __webpack_public_path__ + "img/组 6.a8273091.png";